import AboutImage from "../../assets/imgx.png"
import Cv from "../../assets/developer.pdf"
import { MdOutlineFileDownload } from "react-icons/md"
import Card from "../../components/Card"
import data from "./data"
import "./about.css"

const About = () => {
    return (
        <section id="about" data-aos="fade-in">
            <div className="container about__container">
                <div className="about__left">
                    <div className="about__portrait">
                        <img src={AboutImage} alt="About" />
                    </div>

                </div>
                <div className="about__right">
                    <h2>About Me</h2>
                    <div className="about__cards">
                        {
                            data.map(item => (
                                <Card key={item.id} className="about__card">
                                    <span className="about__card-icon">{item.icon}</span>
                                    <h5>{item.title}</h5>
                                    <small>{item.desc}</small>
                                </Card>
                            ))
                        }
                    </div>
                    <p>
                        Hello, my name is Joseph and I am a passionate web developer with a year experience.
                        I have a strong understanding of modern web technologies and a proven track record of delivering high-quality, interactive and responsive websites and applications.
                        My expertise lies in developing dynamic and user-friendly websites using HTML, CSS, JavaScript and various frameworks such as React, Node.js.
                    </p>

                    <p>
                        I am dedicated to staying up-to-date with the latest web development trends and technologies, and I am always looking for new challenges and opportunities to enhance my skills.
                        I take pride in my ability to turn complex problems into simple and elegant solutions and strive to create visually appealing, functional and accessible websites that provide a seamless user experience.
                        Whether you're looking to revamp your existing website or build a brand new one, I am here to help and ensure that your project is delivered on-time, within budget, and to the highest standard.
                    </p>

                    <a href={Cv} download className="btn primary">Download CV <MdOutlineFileDownload /> </a>

                </div>
            </div>
        </section>
    )
}

export default About


